import { render, staticRenderFns } from "./NotificationsGuide.vue?vue&type=template&id=a03258fa&scoped=true"
import script from "./NotificationsGuide.vue?vue&type=script&lang=js"
export * from "./NotificationsGuide.vue?vue&type=script&lang=js"
import style0 from "./NotificationsGuide.vue?vue&type=style&index=0&id=a03258fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03258fa",
  null
  
)

export default component.exports